import ThumbUpOutline from './ThumbUpOutline'

export default ThumbUpOutline
// eslint-disable-next-line import/export
export * from './ThumbUpOutline'
